import { defineStore } from 'pinia'

import type { DemoShiftControlStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useDemoShiftControlStore = defineStore('demo-shift-control', {
  state: (): DemoShiftControlStore => ({
    loading: false,
    metrics: null,
    filterReservationType: null,
    filterSlotStatus: null,
    filterSortBy: null,
    filterFrom: null,
    filterTo: null,
    slotsPaginatedData: null,
    waitingBookings: [],
  }),
  actions,
  getters,
})
